<template>
    <div class="page-container">
        <div class="purchase-status-block">
            <div class="status-text">
                <!-- <div class="status">已完成</div>
                <div class="status-aside">您的进货单已审核，库存已经更新</div> -->

                <!-- <div class="status">待发货</div>
                <div class="status-aside">您的提货单待发货</div> -->

                <!-- <div class="status">待确认</div>
                <div class="status-aside">确认进货后，请往公户转账结算，结算后财务将立即审核入库</div> -->

                <div class="status">兑换成功</div>
                <div class="status-aside">您兑换的商品已经成功添加至库存</div>
            </div>
            <img src="../../assets/icon-purchase-succ.png" class="status-pic">
        </div>
        <div class="page-bottom">
            <div class="list">
                <div class="incentive-item" v-for="(item,index) in goodsList" :key="index">
                    <div class="goods-info-block">
                        <img :src="item.picUrl" class="goods-pic">
                        <div class="goods-detail">
                            <div class="goods-name">{{`${item.name} ${item.degree}度 ${item.capacity}`}}</div>
                            <div class="goods-sku">
                                <span>{{item.unit == '箱' ? '整箱(6瓶)' : '单瓶'}}</span>
                                <span style="color:#3088f5;">x{{item.num}}{{item.unit}}</span>
                            </div>
                            <div class="caigou-price">采购价：¥{{item.price}}/瓶</div>
                        </div>
                    </div>
                    <div class="item-bottom">总价：¥{{item.amount}}</div>
                </div>
            </div>
            <div class="info-block">
                <div class="block-title">兑换单信息</div>
                <div class="info-item">
                    <span>兑换订单号</span>
                    <span>{{pageData.orderNo}}</span>
                </div>
                <div class="info-item">
                    <span>兑换时间</span>
                    <span>{{pageData.createTime | formatCreatetime}}</span>
                </div>
                <!-- <div class="info-item">
                    <span>兑换商品总数量</span>
                    <span>{{pageData.totalNum}}箱</span>
                </div> -->
                <div class="info-item">
                    <span>本次使用金额</span>
                    <span>{{pageData.amount}}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import $http from '@/lib/request'
import config from '@/config'
import {Toast} from 'vant'

export default {
    data(){
        return {
            pageData:{},
            orderId:'',
            goodsList:[],
        }
    },
    components:{
        [Toast.name]:Toast
    },
    activated(){
        this.orderId=this.$route.params.orderId;
        $http({
            method:'post',
            data:{
                orderId:this.orderId
            },
            url:config.api.dhRecordDetail
        }).then(res=>{
            if(res.errno == 0){
                this.pageData=res.data;
                this.goodsList=res.data.goodsList;
            }else{
                Toast(res.errmsg);
            }
        })
    }
}
</script>
<style lang="scss" scoped>
@mixin flex-between{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.page-container{
    min-height:100vh;
    background:#f5f5f5;
    .purchase-status-block{
        padding:20px 36px;
        background: linear-gradient(110deg, #3CA7FE 0%, #3088F5 100%);
        display: flex;
        justify-content: space-between;
        align-items: center;
        .status-text{
            width:230px;
            color:#fff;
            .status{
                font-size: 16px;
                line-height: 22px;
                margin-bottom: 4px;
            }
            .status-aside{
                font-size: 12px;
                line-height: 16px;
            }
        }
        .status-pic{
            width:60px;
            height:60px;
        }
    }
    .page-bottom{
        padding:10px;
        .list{
            .incentive-item{
                background:#fff;
                border-radius: 4px;
                padding:0 15px;
                margin-bottom: 10px;
                .goods-info-block{
                    display: flex;
                    justify-content: flex-start;
                    padding:15px 0;
                    .goods-pic{
                        width:80px;
                        height:80px;
                        margin-right: 10px;
                        border-radius: 4px;
                    }
                    .goods-detail{
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        width:calc(100% - 70px);
                        .goods-name{
                            overflow: hidden;
                            text-overflow:ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            color:#000;
                            line-height: 20px;
                            font-size: 14px;
                        }
                        .goods-sku{
                            @include flex-between();
                            color:#999;
                            line-height: 18px;
                            font-size: 12px;
                        }
                        .caigou-price{
                            color:#999;
                            line-height: 18px;
                            font-size: 12px;
                        }
                    }
                }
                .item-bottom{
                    text-align: right;
                    color:#3088F5;
                    font-size: 14px;
                    line-height: 20px;
                    padding-bottom: 15px;
                }
            }
        }
        .info-block{
            padding:15px;
            background:#fff;
            border-radius: 4px;
            .block-title{
                font-size: 14px;
                color:#333;
                padding-bottom:15px;
            }
            .info-item{
                color:#666;
                line-height: 18px;
                padding:4px 0;
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 13px;
                &>span{
                    &:last-child{
                        text-align: right;
                        color:#333;
                    }
                }
            }
        }
    }
}
</style>